import { ADS_CAMPAIGN_FOLDER_CONTENTS_ROOT } from "./constants";

export const getAdsCampaignFolderContentIndexPath = ({
  advertiserID,
  folderID,
  campaignID,
}) =>
  `${ADS_CAMPAIGN_FOLDER_CONTENTS_ROOT}/${advertiserID}/${folderID}/${campaignID}`;

export const getAdsCampaignRecordPath = ({ advertiserID, campaignID }) =>
  `adsCampaigns/${advertiserID}/${campaignID}`;

export const buildAdsCampaignFolderMembershipUpdates = ({
  advertiserID,
  campaignRecords = [],
  folderID = null,
}) => {
  const updates = {};
  const campaignIDs = [];

  campaignRecords.forEach(({ campaignID, previousFolderID }) => {
    if (!campaignID) return;
    if (folderID && previousFolderID === folderID) return;
    if (!folderID && !previousFolderID) return;

    if (previousFolderID) {
      updates[
        getAdsCampaignFolderContentIndexPath({
          advertiserID,
          folderID: previousFolderID,
          campaignID,
        })
      ] = null;
    }

    const recordPath = getAdsCampaignRecordPath({ advertiserID, campaignID });
    if (folderID) {
      updates[
        getAdsCampaignFolderContentIndexPath({
          advertiserID,
          folderID,
          campaignID,
        })
      ] = true;
      updates[`${recordPath}/folderID`] = folderID;
    } else {
      updates[`${recordPath}/folderID`] = null;
    }

    campaignIDs.push(campaignID);
  });

  return { updates, campaignIDs };
};
